import { useState } from 'react'
import { estiloDeBoton } from '@/shared/lib/estilosDeBoton'
import { X, Link as LinkIcon, Copy, Check } from 'lucide-react'

interface ShareLinkModalProps {
  isOpen: boolean
  onClose: () => void
  invitationLink: string
  supplierName?: string
}

const ShareLinkModal = ({ isOpen, onClose, invitationLink, supplierName: _supplierName }: ShareLinkModalProps) => {
  const [copied, setCopied] = useState(false)

  if (!isOpen) return null

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(invitationLink)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // Fallback para navegadores antiguos
      const textArea = document.createElement('textarea')
      textArea.value = invitationLink
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-xl max-w-2xl w-full mx-4 p-8 animate-fadeIn">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Content */}
        <div>
          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Compartir enlace
          </h2>

          {/* Message */}
          <p className="text-gray-700 mb-6 leading-relaxed">
            El proveedor pasó el primer filtro y no se encontraron registros en listas negras.
            <br />
            Puedes compartir el enlace de invitación.
          </p>

          {/* Link Box */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 flex items-center gap-3">
            <LinkIcon className="w-5 h-5 text-blue-600 flex-shrink-0" />
            
            <div className="flex-1 overflow-hidden">
              <p className="text-sm text-blue-600 truncate">
                {invitationLink}
              </p>
            </div>

            <button
              onClick={handleCopy}
              className={estiloDeBoton('primario', 'flex-shrink-0')}
            >
              {copied ? (
                <>
                  <Check className="w-4 h-4" />
                  Copiado
                </>
              ) : (
                <>
                  <Copy className="w-4 h-4" />
                  Copiar
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShareLinkModal
